import React, {useEffect, useState} from "react";
import {ResponseInterface} from "../../../../interfaces/ResponseInterface";
import {LogInterface, structLog} from "../../../../interfaces/private/LogInterface";
import {PaginationInterface, structPagination} from "../../../../interfaces/PaginationInterface";
import QPagination from "../../../../common/components/QPaging";
import QLoading from "../../../../common/components/QLoading";
import {UseMainLayout} from "../../../../context/LayoutContext";
import QSearch from "../../../../common/components/Genneral/QSearch";
import {config} from "../../../../config";
import QHeaderTable from "../../../../common/components/Genneral/QHeaderTable";
import {OrderConfig} from "./config";
import QSelectPerPage from "../../../../common/components/Genneral/QSelectPerPage";
import {useTranslation} from "react-i18next";
import LogApi from "../../../../common/api/functions/v2/Log";
import IntegrateApi from "../../../../common/api/functions/v2/Integrate";
import QModal from "../../../../common/components/QModal";
import BodyModalIntegrationComponent from "../components/BodyModalIntegrationComponent";
import BodyModalLogDetailComponent from "../components/BodyModalLogDetailComponent";
import LogFilters from "../components/LogFilters";
import LogTableBody from "../components/LogTableBody";
import {useDispatch} from "react-redux";
import {setToast} from "../../../../app/rootReducer";
import SetupApi from "../../../../common/api/functions/Setup";
import BodyModalMessageSetupComponent from "../components/BodyModalMessageSetupComponent";
import {getMissingSetupKeys, isCheckSetupComplete, SetupLinkKey} from "../../../../common/helpers/checkSetup";

const Subscription = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const [openModalIntegration, setOpenModalIntegration] = useState(false);
    const [openMessageSetup, setOpenMessageSetup] = useState(false);
    const [missingSetup, setMissingSetup] = useState<SetupLinkKey[]>([])
    const [loadingSetup, setLoadingSetup] = useState(false);
    const [openModalLogDetail, setOpenModalLogDetail] = useState(false);
    const [progress,setProgress] = useState(0);
    const [logs, setLogs] = useState<Array<LogInterface>>([]);
    const [log, setLog] = useState<LogInterface>(structLog);
    const [pagination, setPagination] = useState<PaginationInterface | any>({
        ...structPagination,type:'subscription'
    })
    const [loading, setLoading] = useState(true);
    const [loadingLogDetail, setLoadingLogDetail] = useState(false);
    UseMainLayout();

    useEffect(() => {
        if (loading) {
            loadLog().then(async () => {
                await setLoading(false);
            });
        }
        // Loading is the explicit refresh trigger; pagination is read when that trigger changes.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading])

    const loadLog = async () => {
        try {
            await LogApi.getAll(pagination).then(async (response: ResponseInterface | any) => {
                if (response.status === config.STATUS_CODE.OK) {
                    response = response.data.data;
                    setLogs(
                        response?.data || []
                    )
                    setPagination({
                        ...pagination,
                        page: response.current_page,
                        total: response.total,
                        per_page: response.per_page
                    })
                }
            })

        } catch (err) {
            dispatch(setToast({message: t("log.load_failed"), type: config.TOAST_TYPE.ERROR}));
        }
        if (loading) {
            await setLoading(false);
        }
    }

    const callIntegration = async(params:any) => {
        setProgress(1);
        try {
            const response: ResponseInterface | any = await IntegrateApi.syncSubscription(params);
            setProgress(100);
            await loadLog();
            return response;
        } catch (error) {
            setProgress(0);
            dispatch(setToast({message: t("log.sync_failed"), type: config.TOAST_TYPE.ERROR}));
        }
    };

    const handleViewLogDetail = async (_id: string | number) => {
        setLoadingLogDetail(true);
        setOpenModalLogDetail(true);
        try {
            const response: ResponseInterface | any = await LogApi.getDetail(_id);
            if(response?.data?.data){
                setLog(response?.data?.data);
            }
        } catch (error) {
            setOpenModalLogDetail(false);
            dispatch(setToast({message: t("log.detail_failed"), type: config.TOAST_TYPE.ERROR}));
        } finally {
            setLoadingLogDetail(false);
        }
    };


    const checkSetup = async () => {
        setLoadingSetup(true);
        try {
            const response: ResponseInterface | any = await SetupApi.checkSetup('subscription');
            if (response?.data?.data) {
                const data = response.data.data;
                if (isCheckSetupComplete(data)) {
                    setOpenModalIntegration(true);
                } else {
                    setMissingSetup(getMissingSetupKeys(data));
                    setOpenMessageSetup(true);
                }
            }
        } catch (error) {
            dispatch(setToast({message: t("log.setup_check_failed"), type: config.TOAST_TYPE.ERROR}));
        } finally {
            setLoadingSetup(false);
        }
    };

    return (
        <React.Fragment>

            <QModal
                open={openMessageSetup}
                setOpen={setOpenMessageSetup}
                headerContent={t("log.setup_notice_title")}
                bodyContent={(
                    <BodyModalMessageSetupComponent missing={missingSetup} />
                )}
            />
            <QModal
                open={openModalIntegration}
                setOpen={setOpenModalIntegration}
                headerContent={t("common.modal.integration")}
                bodyContent={(
                    <BodyModalIntegrationComponent
                        setOpen={setOpenModalIntegration}
                        open={openModalIntegration}
                        callIntegration={callIntegration}
                        progress={progress}
                    />
                )}
                onClosed={()=>setProgress(0)}
                // onOpened={()=>setProgress(0)}

            />
            <QModal
                size={'xl'}
                open={openModalLogDetail}
                setOpen={setOpenModalLogDetail}
                headerContent={t("log.detail")}
                onClosed={()=>  setLog(structLog)}
                bodyContent={(
                    <BodyModalLogDetailComponent
                        setOpen={setOpenModalLogDetail}
                        open={openModalLogDetail}
                        setLoading={setLoadingLogDetail}
                        loading={loadingLogDetail}
                        log={log}
                    />
                )}

            />
            <div className="col-md-12">
                <div className="row ">
                    <div className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                            <div>
                                <div className="page-title-name">{t("common.heading.subscriptions")}</div>
                                <p className="text-muted small mb-0 mt-1">{t("economic.sectionSubscriptionHelp")}</p>
                            </div>
                            <div className="page-title-right">
                                <div className="d-flex">
                                    <button type="button" className="btn btn-sm bg-orange-zp ml-3" onClick={() => checkSetup()}><span><i
                                        className="lab la-telegram mr-1"></i> {t("common.heading.manualIntegration")}</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="mb-3">
                            <div className="card-header align-items-center d-flex flex-wrap gap-2">
                                <div className="mb-0 flex-grow-1">
                                    <ul className="nav nav-tabs nav-tabs-custom nav-success bd-none" role="tablist">
                                    </ul>
                                </div>
                                <LogFilters pagination={pagination} setPagination={setPagination}
                                            setLoading={setLoading}/>
                                <QSearch
                                    onChange={async (value: string) => {
                                        await setPagination({
                                            ...pagination,
                                            search: value,
                                        })
                                        await setLoading(true);
                                    }}
                                />
                                <QSelectPerPage pagination={pagination} setPagination={setPagination}
                                                setLoading={setLoading}/>
                            </div>
                            <QLoading loading={loading || loadingSetup}/>
                            <div className="table-responsive">
                            <table className="table align-middle table-nowrap mb-0" id="customerTable">
                                <QHeaderTable
                                    paging={pagination}
                                    setPaging={async (p: any) => {
                                        await setPagination(p);
                                        await setLoading(true);
                                    }}
                                    headers={OrderConfig.headers(t)}
                                />
                                <LogTableBody logs={logs} onView={handleViewLogDetail}/>
                            </table>
                            </div>
                        </div>
                        <QPagination
                            pagination={pagination}
                            setPagination={setPagination}
                            setLoading={setLoading}
                        />
                    </div>
                </div>
            </div>

        </React.Fragment>
    )
}
export default React.memo(Subscription);
